import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { PRIVACY_POLICY } from '../data/legalContent';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-602">
      {/* Header */}
      <div className="bg-white border-b border-gray-200" data-id="element-603">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-604">
          <a href="/" className="inline-flex items-center text-purple-600 hover:text-purple-700 font-medium transition-colors" data-id="element-605">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-606" />
            Back to Home
          </a>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-607">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-608">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-id="element-609">
            Privacy Policy
          </h1>

          <div className="prose prose-sm max-w-none" data-id="element-610">
            {PRIVACY_POLICY.split('\n\n').map((paragraph, index) => {
            const isHeading = paragraph.match(/^[A-Z\s]+$/) || paragraph.match(/^\d+\.\s+[A-Z]/);
            const isSubheading = paragraph.match(/^[A-Z][a-z\s]+:$/);
            if (paragraph === 'Privacy Policy') {
              return null; // Skip duplicate title
            }
            if (paragraph.startsWith('Last Updated:')) {
              return <p key={index} className="text-sm text-gray-500 mb-8" data-id="element-611">
                    {paragraph}
                  </p>;
            }
            if (isHeading) {
              return <h2 key={index} className="text-xl font-bold text-gray-900 mt-8 mb-4" data-id="element-612">
                    {paragraph}
                  </h2>;
            }
            if (isSubheading) {
              return <h3 key={index} className="text-lg font-semibold text-gray-800 mt-6 mb-3" data-id="element-613">
                    {paragraph}
                  </h3>;
            }
            return <p key={index} className="text-gray-700 leading-relaxed mb-4" data-id="element-614">
                  {paragraph}
                </p>;
          })}
          </div>
        </div>
      </div>
    </div>;
}